import { useContext } from 'react'
import Input from '@talkdesk/cobalt-react-input'
import Button from '@talkdesk/cobalt-react-button'
import Label from '@talkdesk/cobalt-react-label'
import Box from '@talkdesk/cobalt-react-box'
import MFAHeader from '../../components/MFAHeader'
import ErrorMessage from '../../components/ErrorMessage'
import useMFA from '../../hooks/useMFA'
import { LoginContext } from '../../contexts/Login'
import {
  TOTP_TITLE,
  TOTP_DESCRIPTION,
  INVALID_TOTP_ERROR_MESSAGE,
  GENERIC_TOTP_ERROR_MESSAGE,
  VERIFICATION_CODE,
  VERIFY
} from '../../constants/ui.labels'
import * as MFATypes from '../../constants/mfa.types'

export const TOTP = ({ csrf, ctx, redirect }) => {
  const {
    code,
    showError,
    verifyButtonState,
    disabledForm,
    errorMessage,
    isVerifyButtonDisabled,
    handleCodeChange,
    doLogin
  } = useMFA({
    redirect,
    invalidCodeErrorMessage: () => INVALID_TOTP_ERROR_MESSAGE,
    genericErrorMessage: () => GENERIC_TOTP_ERROR_MESSAGE
  })

  const handleSubmit = () => {
    const mfa = {
      type: MFATypes.TOTP,
      payload: {
        totp: code
      }
    }
    doLogin(csrf, ctx.credentials, mfa)
  }

  return (
    <>
      <MFAHeader
        icon="phonelink_lock"
        iconColor="green600"
        title={TOTP_TITLE}
        subtitle={TOTP_DESCRIPTION}
      />
      <form
        onSubmit={e => {
          e.preventDefault()
          handleSubmit()
        }}
      >
        {showError ? <ErrorMessage message={errorMessage} /> : null}
        <div>
          <Label htmlFor="totp-code">{VERIFICATION_CODE}</Label>
          <Box paddingTop={2} />
          <Input
            id="totp-code"
            autoFocus
            value={code}
            onChange={handleCodeChange}
            placeholder={VERIFICATION_CODE}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            disabled={disabledForm}
          />
        </div>
        <Box paddingTop={4} />
        <Button
          htmlType="submit"
          disabled={isVerifyButtonDisabled()}
          state={verifyButtonState}
          type="primary"
          shape="full-width"
        >
          {VERIFY}
        </Button>
      </form>
    </>
  )
}

const TOTPWithContext = props => {
  const ctx = useContext(LoginContext)
  return <TOTP ctx={ctx} {...props} />
}
TOTPWithContext.displayName = 'TOTP'

export default TOTPWithContext
